<template>
  <auth-wrapper>
    <form
      class="auth"
      @submit.prevent="signIn"
    >
      <div class="auth-block__data">
        <div class="input-block">
          <label
            class="input-block__label"
            :class="{'input-block__label_error': error}"
            for="login"
          >
            {{ $t('common.login') }}
            <span
              v-if="error"
              class="error-text"
            >
              {{ error }}
            </span>
          </label>
          <input
            id="login"
            v-model="login"
            class="input-block__input"
            :class="{'input-block__input_error': error}"
            autocomplete="username"
            @input="resetValidation"
          >
        </div>
        <div class="input-block">
          <label
            class="input-block__label"
            for="password"
          >
            {{ $t('common.password') }}
          </label>
          <input
            id="password"
            v-model="password"
            class="input-block__input"
            autocomplete="current-password"
            type="password"
            @input="resetValidation"
          >
        </div>
        <!-- eslint-disable-next-line max-len -->
        <div class="custom-control custom-checkbox mt-2 d-flex justify-content-center spdo-custom-control">
          <input
            id="remember-me"
            v-model="rememberMe"
            class="custom-control-input"
            type="checkbox"
          >
          <label
            class="custom-control-label"
            for="remember-me"
          >
            {{ $t('views.sign_in.remember_me') }}
          </label>
        </div>
      </div>
      <div class="actions-block-sso">
        <sso-realm-button
          v-for="sso in realms"
          :key="sso.realm"
          :realm="sso.realm"
          :logo="sso.logo"
          @click="signInRealm(sso.realm)"
        />
        <button
          :disabled="false"
          class="btn spdo-button spdo-button_line spdo-button_filled_white-color"
          type="submit"
        >
          {{ $t('views.sign_in.sign_in') }}
        </button>
      </div>

      <div class="forget">
        <router-link
          class="forget__text"
          :to="{name: 'ResetPassword'}"
          tag="span"
        >
          {{ $t('views.sign_in.forgot_password') }}
        </router-link>
      </div>
    </form>
  </auth-wrapper>
</template>

<script>
import { mapState } from 'vuex';
import AuthWrapper from '@/components/auth/AuthWrapper';
import SsoRealmButton from '@/components/auth/SsoRealmButton';
import VueRouter from 'vue-router';

const { isNavigationFailure, NavigationFailureType } = VueRouter;
export default {
  name: 'SignIn',
  components: {
    AuthWrapper,
    SsoRealmButton,
  },
  data: () => ({
    login: '',
    password: '',
    rememberMe: false,
    error: '',
    realms: [],
  }),
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.realms = this.$keycloak.config || [];
  },
  methods: {
    async signIn() {
      try {
        const { data } = await this.$http.$token.post('main/login', {
          login: this.login,
          password: this.password,
        });
        const { jwtacc, refreshToken } = data;
        if (jwtacc) {
          await this.$store.dispatch('performAuth', {
            jwtacc, refreshToken, locale: this.$i18n.locale, app: this,
          });
        }

        this.$store.commit('setRealm', '');
        this.$router.push('/').catch((failure) => {
          if (!isNavigationFailure(failure, NavigationFailureType.redirected)) {
            throw failure;
          }
        });
      } catch (e) {
        this.$log.debug('Catch on main/login');
        this.error = e.response.data.message;
      }
    },
    resetValidation() {
      this.error = '';
    },
    async signInRealm(sso) {
      const oldRealm = this.$store.realm;

      if (oldRealm && oldRealm !== sso && this.$keycloak.adapters[oldRealm].realm) {
        this.$keycloak.adapters[oldRealm].logout();
      }

      this.$store.commit('setRealm', sso);

      if (!this.$keycloak.adapters[sso].realm) {
        await this.$keycloak.initRealm(sso);
      }

      return this.$keycloak.adapters[sso].login({ redirectUri: `${window.location.origin}/` });
    },
  },
};
</script>

<style lang="scss" scoped>
  .forget {
    display: flex;
    justify-content: center;

    &__text {
      color: var(--margaritas);
      cursor: pointer;
      border-bottom: 1px solid var(--margaritas);
      transition: 0.3s ease-in-out;
      transition-property: color, border-bottom-color;

      &:hover {
        color: var(--aurum);
        border-bottom-color: var(--aurum);
      }
    }
  }
  .actions-block-sso {
    display: flex;
    gap: 1rem;
    grid-auto-columns: repeat(auto-fill, 120px);
    justify-content: center;

    &__switch-component {
      text-transform: uppercase;
      font-weight: 300;
      color: var(--aurum);
      cursor: pointer;
      transition: color 0.3s ease-in-out;

      &:hover {
        color: var(--margaritas);
      }
    }
  }
</style>
